/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { requestOTPFromDeviceRequestSchema } from "./requestOTPFromDeviceRequestSchema.ts";
import { verifyMethodSchema } from "./verifyMethodSchema.ts";

export const deviceAuthRequestOtpCreateStatus200Schema = verifyMethodSchema.describe("Сериализатор ответа успешной отправки ОТП-кода.");

export const deviceAuthRequestOtpCreateStatus400Schema = errorResponseSchema;

export const deviceAuthRequestOtpCreateStatus404Schema = errorResponseSchema;

export const deviceAuthRequestOtpCreateStatus503Schema = errorResponseSchema;

export const deviceAuthRequestOtpCreateResponseSchema = z.union([
	deviceAuthRequestOtpCreateStatus200Schema,
	deviceAuthRequestOtpCreateStatus400Schema,
	deviceAuthRequestOtpCreateStatus404Schema,
	deviceAuthRequestOtpCreateStatus503Schema,
]);

export const deviceAuthRequestOtpCreateDataSchemaJson = requestOTPFromDeviceRequestSchema;

export const deviceAuthRequestOtpCreateDataSchemaXml = requestOTPFromDeviceRequestSchema;

export const deviceAuthRequestOtpCreateDataSchema = z.union([deviceAuthRequestOtpCreateDataSchemaJson, deviceAuthRequestOtpCreateDataSchemaXml]);
